import { useState } from "react";
import BWStatusFilter from "./BWStatusFilter";
import CategoryFilter from "./CategoryFilter";
import { useDispatch } from "react-redux";
import CommonGrid from "../CommonGrid/CommonGrid";
import {
  getProjectGridColumns,
  projectGridFilters,
  projectGridGlobalFilterFields,
} from "./gridConfig";
import ExportSelectedRows from "../../ExportCSV";
import "./ModuleGrids.scss";

const ProjectGrid = ({
  data = [],
  mode = "min",
  dataKey = "AWMProjectID",
  emptyMessage = "No project(s) found.",
  tableProps = {},
  rows = 20,
  paginator,
  title = ""
}) => {
  const bwOptions = [
    { label: "On Track", value: "onTrack" },
    { label: "At Risk", value: "atRisk" },
    { label: "Off Track", value: "offTrack" },
  ];
  const [bwValue, setBwValue] = useState(dataKey.includes("FL") ? ["offTrack"] : []);
  const [categoryValue, setCategoryValue] = useState([]);
  const dispatch = useDispatch();
  const baseUrl = window.location.origin + "/allProjects";

  // Use shared columns definition
  const columns = getProjectGridColumns(mode, dispatch);

  // Use shared filters/globalFilterFields
  const maximizedFilters = projectGridFilters;
  const maximizedGlobalFilterFields = projectGridGlobalFilterFields;

  // Helper to get B:W status from value
  const getBWStatus = (value) => {
    // Convert to number if it's a string
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    
    if (numValue <= 0) return "offTrack";
    if (numValue > 0 && numValue <= 0.3) return "atRisk";
    if (numValue > 0.3) return "onTrack";
    return null;
  };

  // Filter data based on selected B:W and Category values
  let filteredData = data;
  if (mode === "max" && bwValue.length > 0) {
    filteredData = filteredData.filter((row) => {
      // Check both BufferToWorkRatio and BufferToWork fields
      const bufferValue = row.BufferToWorkRatio || row.BufferToWork;
      return bwValue.includes(getBWStatus(bufferValue));
    });
  }
  if (mode === "max" && categoryValue.length > 0) {
    filteredData = filteredData.filter((row) => categoryValue.includes(row.Category));
  }
  // Extract unique categories from data
  const categoryOptions = Array.from(
    new Set(data.map((item) => item.Category).filter(Boolean))
  ).map((item) => ({
    label: item,
    value: item,
  }));

  return (
    <>
      {mode === "max" && (
        <div className="project-grid-filters">
          <ExportSelectedRows
            allData={filteredData}
            selectedRows={[]}
            headers={columns?.map(col => col?.field)?.filter(colNames => colNames !== "Artwork_Status")}
            filename={`${title}_Records`}
          />
          <BWStatusFilter bwOptions={bwOptions} value={bwValue} setValue={setBwValue} />
          <CategoryFilter value={categoryValue} setValue={setCategoryValue} getAPI={false} categoryOptions={categoryOptions}
          />
        </div>
      )}
      <CommonGrid
        data={filteredData}
        columns={columns}
        mode={mode}
        filters={mode === "max" ? maximizedFilters : undefined}
        globalFilterFields={mode === "max" ? maximizedGlobalFilterFields : undefined}
        dataKey={dataKey}
        emptyMessage={emptyMessage}
        rows={rows}
        paginator={mode === "max" ? paginator : undefined}
        tableProps={tableProps}
        showACPFilter={true}
      />
    </>
  );
};

export default ProjectGrid;
